export enum PAGES {
    SELECTION = 'selection',
    RESULT = 'results' 
}